import * as types from './types'

export const action = (type, payload?) => ({ type, payload })

export const setOpenExpSession = (dispatch) => (openExpSession) => dispatch(action(types.SET_OPEN_EXP_SESSION, { openExpSession }))

export const setOnReAuth = (dispatch) => (onReAuth) => dispatch(action(types.SET_ON_REAUTH, { onReAuth }))
